import React from "react";
import MainCP  from "../../Components/Carga/MainCP"

const ViewCarga: React.FC = () => <MainCP/>

export default ViewCarga;